import React from 'react';
import arrowSrc from '../../../assets/images/svgs/icons/arrow.svg';
import zoomInSrc from '../../../assets/images/svgs/icons/zoom_in.svg';
import zoomOutSrc from '../../../assets/images/svgs/icons/zoom_out.svg';
import arrowUpHeadSrc from '../../../assets/images/svgs/icons/arrow_up_head.svg';

const NextButton = (props) => {
	return (
		<div key={'the-button'} className={props.isNextStepDisabled ? "long-btn long-btn--hidden" : "long-btn" }>
			<button className="btn" disabled={props.isNextStepDisabled} onClick={!props.isNextStepDisabled ? props.handleClick : null}  type="button">
				{props.children}
				<img src={arrowSrc} alt="next arrow icon"/>
			</button>
		</div>
	);
};

const HideModal = ({hideModal, text}) => {

	return (
		<div className={'hide-button'} onClick={hideModal()}>
			{text}
			<span />
		</div>
	)
};

const CloseHelp = ({closeHelp, text}) => {

	return (
		<div className={'hide-button'} onClick={closeHelp()}>
			{text}
			<span />
		</div>
	)
};

const INeedHelp = ({openHelp, text}) => {

	return (
		<div className={'help-button'} onClick={openHelp()}>
			{text}
			<span />
		</div>
	)
};

const ShowZoomModal = ({zoomIn, image}) => {


	const handleClick = () => {
		zoomIn(image);
	};

	return (
		<button className={'zoom-in-button'} onMouseDown={handleClick}>
			<img src={zoomInSrc} alt="zoom in icon"/>
		</button>
	)
};

const HideZoomModal = ({deactivatePopup}) => {
	return (
		<button className={'zoom-out-button'} onMouseDown={deactivatePopup}>
			<img src={zoomOutSrc} alt="zoom out icon"/>
		</button>
	)
};

const ReadMoreOrLess = (props) => {
	return (
		<div>
			<button className={'read-more-or-less-button'} onMouseDown={props.onMouseDown}>
				<span>
					{props.text}
				</span>
				<img src={arrowUpHeadSrc} alt="arrow head icon" className={props.isExpanded ? 'icon up' : 'icon down'} />
			</button>
		</div>
	)
};

export {
	NextButton,
	HideModal,
	CloseHelp,
	INeedHelp,
	ShowZoomModal,
	HideZoomModal,
	ReadMoreOrLess,
}
